module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/crop-team.a74800e8.svg";